<template>
<div class="d-flex justify-content-center" style="margin-top: 20px">
  <b-row>
    <b-col md="12">
      <h1>Confirmação de conta</h1>
      
      Por favor digite uma nova senha.
      <p class="password-comment">
        <small>Ela deve conter pelo menos 1 dígito numérico.</small>
      </p>
      <FormulateForm
        class="login-form"
        v-model="formValues"
        @submit="submitHandler"
      >
          <FormulateInput
            name="password"
            type="password"
            label="Senha"
            placeholder="Senha nova"
            validation="required|passwordRequirement"
            :validation-rules="{
                passwordRequirement: ({value}) => /\d/.test(value)
            }"
            :validation-messages="{
              passwordRequirement: 'A senha deve conter pelo menos 1 dígito.'
            }"
            label-class="custom-label"
          />
          <FormulateInput
            name="password_confirm"
            type="password"
            label="Confirmação de senha"
            placeholder="Confirme aqui sua senha"
            validation="confirm"
            :validation-messages="{
              confirm: 'Senha e confirmação não coincidem',
            }"
            validation-name="Confirmation"
            label-clas="custom-label"
          />

        <FormulateInput
          type="submit"
          label="Confirmar"
        />
      </FormulateForm>
    </b-col>
  </b-row>
  </div>
</template>

<script>
import * as usersApiClient from '../js/usersApiClient'

export default {
  name: 'PasswordReset',
  data() {
    return {
      formValues: {},
      token: this.$route.query.token,
      userId: this.$route.params.id,
    }
  },
  methods: {
    async submitHandler() {
      const result = await usersApiClient.resetPasswordAsync(
        this.userId, this.token, this.formValues.password);

      if (result) {
        window.alert('Senha redefinida com sucesso!');
        this.$router.push('/');
      }
      else {
          window.alert('Erro ao redefinir senha. Verifique sua senha'); 
      }
    }
  }
}
</script>

<style scoped>

.password-comment {
  color: grey;
  margin-top: 10px;
}

.custom-label {
  font-size: 20px;
  color: red;
}

.center {
  text-align: center;
}

.center {
  justify-content: center;
}

.loader {
  margin-left: 10px;
}

</style>
